

import "../styles/ComingSoon.css";

const ResumeAnalysis = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-card">
        <h1>Upload Resume</h1>
        <p>Coming Soon...</p>
      </div>
    </div>
  );
};

export default ResumeAnalysis;
